import React, { useState } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';

const yellow = '#f3e81c';

const BlogPage = styled.div`
  background: ${yellow};
  min-height: 100vh;
  font-family: 'Inter', Arial, sans-serif;
`;

const BlogContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  padding-top: 120px;
  
  @media (max-width: 768px) {
    padding: 1rem;
    padding-top: 100px;
  }
`;

const BlogTitle = styled.h1`
  color: #000000;
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 2.5rem;
  
  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
`;

const Breadcrumbs = styled.div`
  color: #888;
  font-size: 0.95rem;
  margin-bottom: 2rem;
  text-align: center;
`;

const PostsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 2.5rem 2.5rem;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
`;

const PostCard = styled.div`
  border: none;
  border-radius: 18px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 24px rgba(0,0,0,0.07);
  display: flex;
  flex-direction: column;
  transition: transform 0.22s cubic-bezier(.4,0,.2,1), box-shadow 0.22s cubic-bezier(.4,0,.2,1);
  will-change: transform, box-shadow;
  &:hover {
    transform: scale(1.035);
    box-shadow: 0 10px 32px rgba(255,107,0,0.13), 0 2px 8px rgba(0,0,0,0.08);
  }
`;

const PostImage = styled.img`
  width: 100%;
  aspect-ratio: 16/12;
  object-fit: cover;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  display: block;
`;

const PostContent = styled.div`
  padding: 1.2rem 1rem 1rem 1rem;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const PostDate = styled.div`
  color: #888;
  font-size: 0.95rem;
  margin-bottom: 0.5rem;
`;

const PostTitle = styled.h2`
  font-size: 1.25rem;
  color: #222;
  margin: 0 0 0.5rem 0;
`;

const PostExcerpt = styled.p`
  color: #444;
  font-size: 1.05rem;
  flex: 1;
`;

const ReadMore = styled.button`
  background: #FF6B00;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.8rem 1.5rem;
  margin-top: 1rem;
  cursor: pointer;
  align-self: flex-start;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 107, 0, 0.3);
  &:hover {
    background: #E55A00;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 107, 0, 0.4);
  }
  &:active {
    transform: translateY(-1px);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2rem;
  
  @media (max-width: 768px) {
    padding: 1rem;
    align-items: flex-start;
    padding-top: 2rem;
  }
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 18px;
  padding: 2rem;
  max-width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    padding: 1.5rem;
    max-height: 85vh;
    width: 100%;
    max-width: none;
    margin: 0;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
`;

const ModalTitle = styled.h2`
  color: #222;
  margin: 0;
  font-size: 1.5rem;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  padding: 0.5rem;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  &:hover {
    background: #f0f0f0;
  }
`;

const ModalText = styled.div`
  color: #444;
  font-size: 1.1rem;
  line-height: 1.6;
  white-space: pre-line;
`;

const posts = [
  {
    id: 4,
    title: 'Eveniment: Leodor TikTok Fest: chipsuri gratuite și distracție cu influencerii preferați',
    date: '',
    image: require('../assets/123.jpeg'),
    excerpt: 'Compania Leodor a dat startul distracției prin organizarea evenimentului „Leodor TikTok Fest", unde energia și voia bună au fost ingredientele principale.',
    fullContent: `Eveniment: Leodor TikTok Fest: chipsuri gratuite și distracție cu influencerii preferați

Compania Leodor a dat startul distracției prin organizarea evenimentului „Leodor TikTok Fest", unde energia și voia bună au fost ingredientele principale.

Alături de brand, trei dintre cei mai apreciați creatori de conținut de pe TikTok – Marian Măriuței, Cezar Alexa și Constantin Marian Măriuței – au adus zâmbete și interacțiune autentică fanilor prezenți. Cei trei tiktokeri au împărțit gratuit chipsuri Leodor participanților, transformând degustarea într-o experiență comunitară și plină de entuziasm.

Evenimentul a combinat momente de divertisment, întâlniri cu influencerii și atmosfera prietenoasă specifică TikTok-ului. Leodor a urmărit astfel să fie mai aproape de tineri, să creeze conexiuni reale și să ofere o experiență memorabilă, într-un mod fresh și inovator.

👉 „Leodor TikTok Fest" marchează o nouă etapă în modul în care brandurile aleg să interacționeze cu publicul: prin experiențe interactive și implicarea directă a creatorilor de conținut.`,
  },
  {
    id: 3,
    title: 'Eveniment: Disney Day la Aqua City Vara Vara!',
    date: '2025-08-03',
    image: require('../assets/itc6u26b.png'),
    excerpt: 'Veți fi întâmpinați de personaje de poveste, urmate de o paradă magică a eroilor care vor aduce bucurie atât celor mici, cât și celor mari. Animație, dansuri, aqua aerobic, flashmoburi, hore, spumă și — bineînțeles — înghețată pentru toți la finalul zilei!',
    fullContent: `Disney Day la Aqua City Vara Vara!

📅 3 august

📍 VaraVara AquaCity

O sărbătoare a copilăriei, magiei și basmelor!

Bine ați venit în lumea magică, unde personajele preferate prind viață chiar lângă piscină! Vă așteaptă o zi plină de distracție, râsete și emoții de neuitat. Fiecare copil se va simți parte dintr-o poveste adevărată.

Veți fi întâmpinați de personaje de poveste, urmate de o paradă magică a eroilor care vor aduce bucurie atât celor mici, cât și celor mari. Animație, dansuri, aqua aerobic, flashmoburi, hore, spumă și — bineînțeles — înghețată pentru toți la finalul zilei!

Programul zilei:
🕙 10:00-11:00 - Întâmpinarea oaspeților
🕐 12:00-12:15 - Parada Eroilor
🕐 12:15-12:45 - Animație pentru copii cu personajele preferate
🕐 13:00-13:10 - Aqua aerobică de Anul Nou
🕐 13:30-13:35 - Flashmob de Anul Nou + Hora
🕑 14:00-14:30 - Activități interactive în piscină pentru copii
🕔 15:05-15:20 - Dans festiv de Anul Nou
🕕 16:00-16:30 - Animație pentru copii „Grinch"
🕕 16:30-16:40 - Spuma Party
🕕 17:30-18:00 - Activități distractive pe peluză
🕕 18:50 - Înghețată pentru toți

Aventuri subacvatice și jocuri interactive vă așteaptă în piscină, iar peluza verde se va transforma într-o arenă a distracției. Este o zi în care copiii râd, părinții se relaxează, iar magia devine realitate.

Veniți cu toată familia — Disney Day la Vara Vara va rămâne o amintire de neuitat!`,
  },
  {
    id: 2,
    title: 'Eveniment: FESTIVALUL LUPILOR 2025',
    date: '2025-08-08',
    image: require('../assets/LupiiLuiCalancea_Band-1-min.png'),
    excerpt: 'Festivalul Lupilor 2025 aduce pe scenă un lineup spectaculos, reunind artiști din diverse genuri muzicale – de la folk-rock și etno până la alternative, punk și ritmuri electro. Două zile de muzică live, energie explozivă și momente memorabile sub cerul liber, într-un decor natural impresionant!',
    fullContent: `Festivalul Lupilor 2025

📅 08 09 10 august

📍 Rezervația Naturală "Orheiul Vechi"

Festivalul Lupilor 2025 aduce pe scenă un lineup spectaculos, reunind artiști din diverse genuri muzicale – de la folk-rock și etno până la alternative, punk și ritmuri electro. Trei zile de muzică live, energie explozivă și momente memorabile sub cerul liber, într-un decor natural impresionant!

Rezervaţia Naturală "Orheiul Vechi" va găzdui din nou cel mai așteptat festival de muzică alternativă din Moldova. Peisajul unic al acestui loc istoric va crea atmosfera perfectă pentru o experiență muzicală de neuitat.

Lineup-ul festivalului include:
• Artiști folk-rock și etno care vor aduce sunetele tradiționale într-o interpretare modernă
• Formații alternative și punk care vor electriza publicul cu energia lor
• DJ-i și producători de muzică electronică care vor menține atmosfera până în zori

Trei zile complete de muzică, artă, cultură și natură într-unul dintre cele mai frumoase locuri din Moldova. Festivalul Lupilor nu este doar despre muzică – este despre comunitate, despre conexiunea cu natura și despre celebrarea diversității culturale.

Vino să fii parte din această experiență unică!`,
  },
  {
    id: 1,
    title: 'Eveniment: SUMMER FEST 2025',
    date: '2025-08-23',
    image: require('../assets/34343.jpg'),
    excerpt: 'Soare, muzică și vară Summer Fest 2025! 23 și 24 august. Festivalul se va petrece în Grădina Botanică!',
    fullContent: `Summer Fest este un festival care adună nu doar oaspeți din întreaga Moldova, ci și din alte țări și oferă momente de divertisment maxim, soare și emoții intense! În 2025, ne vom distra la a șaptea ediție a festivalului alături de cei dragi în Grădina Botanică.

Când vorbim despre Summer Fest, vorbim despre tot ce e mai bun.

Cel mai bun sunet, cea mai mare scenă, cei mai buni artiști, cea mai imensă locație - asta înseamnă

Summer Fest.

Cel mai grandios festival al anului te invită să te scufunzi în atmosfera plină de energie și entuziasm.

Aici se întâlnesc combinații îndrăznețe de mâncare, divertisment, muzică și relaxare.

Festivalul nostru a devenit deja cel mai așteptat eveniment al verii, o întâlnire anuală a iubitorilor de muzică live în aer liber și un interes a turiștilor care vizitează Moldova.

Fiecare ediție Summer Fest se străduie să depășească pe cea anterioară. Echipa organizatorică, împreună cu partenerii, dezvoltă conceptul festivalului pentru a oferi tot ce e mai bun pentru fiecare oaspete, având în vedere experiența anilor precedenți și tendințele mondiale din industria evenimentelor de divertisment. Datorită colaborării strânse dintre organizatori și parteneri, de la momentul în care Bere Chișinău și Bis-Concert l-au creat în 2017, Summer Fest a crescut deja, până la a 8 ediție, de la un eveniment național la un festival de amploare internațională.

Pentru a șaptea oară, cel mai grandios festival din Moldova te va impresiona cu o varietate de distracții pentru toate vârstele, gustări delicioase, o mulțime de bere rece și, desigur, cu cei mai de top artiști.

Oferă-ți cel mai fierbinte weekend al verei și amintiri de neuitat!

Fă parte din fluxul de energie "Summer Fest"!`,
  },

];

export default function Blog() {
  const [selectedPost, setSelectedPost] = useState(null);

  // Сортируем посты: сначала предстоящие события, затем прошедшие
  const sortedPosts = [...posts].sort((a, b) => {
    const today = new Date();
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    
    const isUpcomingA = dateA >= today;
    const isUpcomingB = dateB >= today;
    
    // Если оба события предстоящие или оба прошедшие, сортируем по дате
    if (isUpcomingA === isUpcomingB) {
      return isUpcomingA ? dateA - dateB : dateB - dateA; // Предстоящие по возрастанию, прошедшие по убыванию
    }
    
    // Предстоящие события идут первыми
    return isUpcomingB - isUpcomingA;
  });

  const handleReadMore = (post) => {
    if (post.fullContent) {
      setSelectedPost(post);
    }
  };

  const handleImageClick = (post) => {
    if (post.id === 1) { // Summer Fest 2025 post
      window.open('https://summerfest.md/', '_blank');
    } else if (post.id === 2) { // Festivalul Lupilor 2025 post
      window.open('https://festivalul-lupilor.md/', '_blank');
    } else if (post.id === 3) { // Disney Day post
      window.open('https://varavara.md/ro/events/disney-day/', '_blank');
    }
  };

  const closeModal = () => {
    setSelectedPost(null);
  };

  return (
    <BlogPage>
      <Header backgroundYellow={true} />
      <BlogContainer>
        <BlogTitle>Evenimente & Noutăți</BlogTitle>
        <PostsGrid>
          {sortedPosts.map(post => (
            <PostCard key={post.id}>
              <PostImage 
                src={post.image} 
                alt={post.title} 
                onClick={() => handleImageClick(post)}
                style={{ 
                  cursor: (post.id === 1 || post.id === 2 || post.id === 3) ? 'pointer' : 'default',
                  transition: 'transform 0.2s ease',
                  objectFit: 'cover',
                  objectPosition: post.id === 2 ? 'center top' : post.id === 3 ? 'center center' : 'center center'
                }}
                onMouseEnter={(e) => {
                  if (post.id === 1 || post.id === 2 || post.id === 3) {
                    e.target.style.transform = 'scale(1.02)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (post.id === 1 || post.id === 2 || post.id === 3) {
                    e.target.style.transform = 'scale(1)';
                  }
                }}
              />
              <PostContent>
                {post.date && <PostDate>{new Date(post.date).toLocaleDateString('ro-RO')}</PostDate>}
                <PostTitle>{post.title}</PostTitle>
                <PostExcerpt>{post.excerpt}</PostExcerpt>
                <ReadMore onClick={() => handleReadMore(post)}>
                  Citeste mai mult
                </ReadMore>
              </PostContent>
            </PostCard>
          ))}
        </PostsGrid>
      </BlogContainer>
      
      {selectedPost && (
        <ModalOverlay onClick={closeModal}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>{selectedPost.title}</ModalTitle>
              <CloseButton onClick={closeModal}>×</CloseButton>
            </ModalHeader>
            <ModalText>{selectedPost.fullContent}</ModalText>
          </ModalContent>
        </ModalOverlay>
      )}
    </BlogPage>
  );
}